import { render } from "./Loading.vue?vue&type=template&id=1fc3d1a7&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1fc3d1a7"

export default script